"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Response_1 = __importDefault(require("../Response"));
class SuccessResponse extends Response_1.default {
    constructor(statusCode, body) {
        if (statusCode < 200 || statusCode > 299) {
            throw new Error(`${statusCode} is not a successful status code`);
        }
        super(statusCode, body);
    }
}
exports.default = SuccessResponse;
